import React, { ComponentProps, FC } from 'react';

import { useLeftJoinAudioTracks } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Tracks/hooks/useLeftJoinAudioTracks';
import { useInnerJoinAudioTracks } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Tracks/hooks/useInnerJoinAudioTracks';
import { useAudioTracks } from '@/scenarios/legacy-player/hooks/useAudioTracks';
import { useCurrentAudioTrack } from '@/scenarios/legacy-player/hooks/useCurrentAudioTrack';

import { AudiosConfig } from '../../../../Player';

import { AudioSettingPopupButton } from './component';

interface Props
    extends Omit<ComponentProps<typeof AudioSettingPopupButton>, 'currentAudioTrack' | 'audio'> {
    audioTracks?: AudiosConfig;
    withAudioTracksIntersection?: boolean;
}

export const AudioSettingPopupButtonContainer: FC<Props> = ({
    contentId,
    audioTracks,
    withAudioTracksIntersection = false,
    ...props
}) => {
    const currentAudioTracks = useCurrentAudioTrack();
    const playerAudioTracks = useAudioTracks();

    const leftJoinAudio = useLeftJoinAudioTracks(playerAudioTracks, audioTracks);
    const innerJoinAudio = useInnerJoinAudioTracks(playerAudioTracks, audioTracks);

    return (
        <AudioSettingPopupButton
            contentId={contentId}
            currentAudioTrack={currentAudioTracks}
            audio={withAudioTracksIntersection ? innerJoinAudio : leftJoinAudio}
            {...props}
        />
    );
};
